import AES from 'crypto-js/aes';
import utf8 from 'crypto-js/enc-utf8';

import Logger from '../utils/logger';
import { UserSession } from './types';
import { deleteCookie, getCookie, setCookie } from '../utils/cookies';

const SESSION_KEY = 'acadlySession';
const SESSION_SECRET = process.env.REACT_APP_SESSION_SECRET || 'secret';
const USER_ID_LOCAL_STORAGE_KEY = 'acadlyUserId';
/**
 * Stores encrypted session-data to browser local-storage to make state persistent
 * @param user session data of user
 */
export function setSession(session: (UserSession & { isAuthenticated?: boolean }) | null) {
  if (!session) {
    deleteCookie(SESSION_KEY);
    localStorage.clear();
    return;
  }

  const sessionStr = JSON.stringify(session);
  const sessionCipher = AES.encrypt(sessionStr, SESSION_SECRET).toString();
  setCookie(SESSION_KEY, sessionCipher);
}

/**
 * Gets and decrypts the user's session-data from browser local-storage
 */
export function getSession(): (UserSession & { isAuthenticated?: boolean }) | null {
  const sessionCipher = getCookie(SESSION_KEY);

  if (!sessionCipher) return null;

  try {
    const bytes = AES.decrypt(sessionCipher, SESSION_SECRET);
    return JSON.parse(bytes.toString(utf8));
  } catch (error) {
    Logger.error(error);
    return null;
  }
}

export function setUserId(userId: string) {
  const userIdStr = JSON.stringify(userId);
  const userIdCipher = AES.encrypt(userIdStr, SESSION_SECRET).toString();
  localStorage.setItem(USER_ID_LOCAL_STORAGE_KEY, JSON.stringify(userIdCipher));
}

export function getUserId() {
  const userIdCipher = JSON.parse(localStorage.getItem(USER_ID_LOCAL_STORAGE_KEY) ?? '""');

  if (!userIdCipher) return;

  try {
    const bytes = AES.decrypt(userIdCipher, SESSION_SECRET);
    return JSON.parse(bytes.toString(utf8));
  } catch (error) {
    Logger.error(error);
    return null;
  }
}
